import ReactOnRails from 'react-on-rails';

import SubscribeTest from '@components/pages/SubscribeTest/index';

ReactOnRails.register({
  SubscribeTest,
});
